import React from 'react';
import { Helmet } from 'react-helmet';

const SEOHelmet = ({ title, description, keywords, canonicalUrl, ogImage }) => {
  const siteTitle = '5N1PR İletişim Danışmanlığı';
  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content="5N1PR İletişim Danışmanlığı" />
      
      {/* Canonical URL */}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content={siteTitle} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      
      {/* Schema.org markup */}
      <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            "name": "5N1PR İletişim Danışmanlığı",
            "description": "${description}",
            "url": "${canonicalUrl || 'https://www.5n1pr.com'}",
            "logo": "${ogImage || 'https://www.5n1pr.com/logo.png'}",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Levent Mahallesi, İş Caddesi No:123",
              "addressLocality": "Beşiktaş",
              "addressRegion": "İstanbul",
              "postalCode": "34330",
              "addressCountry": "TR"
            },
            "telephone": "+90 (212) 123 45 67",
            "email": "info@5n1pr.com",
            "openingHours": "Mo-Fr 09:00-18:00"
          }
        `}
      </script>
    </Helmet>
  );
};

export default SEOHelmet;
